module.exports = __webpack_public_path__ + "assets/img/ZT8212-M.8bd04f3e.png";